<template>
    <div class="d-flex justify-content-end align-items-center justify-items-end">
        <!-- Review Order Button -->
        <button
            v-if="order.can.review"
            class="btn btn-secondary btn-fixed-width"
            @click="openReview"
        >
            Review Order
        </button>

        <!-- Download/Share (when can't review) -->
        <template v-else>
            <download-order-items
                download-type="creative"
                :query="{ filter: { id: order.creative_ids } }"
            ></download-order-items>
            <share-order-items
                share-type="creative"
                :query="{ filter: { id: order.creative_ids } }"
            ></share-order-items>
            <button
                class="btn btn-fixed-width btn-sm btn-primary"
                @click="openViewCreative"
            >
                View Creative
            </button>
        </template>

        <!-- Verify Items Dropdown -->
        <div
            v-if="order.can.verify_items"
            class="btn-group"
            role="group"
            title="For every asset, confirm it has been Fulfilled to initiate payment or mark as Unfulfilled if there's an issue."
            v-b-tooltip.hover
        >
            <button
                id="btnGroupDropVerify"
                type="button"
                class="btn dropdown-toggle btn-primary btn-fixed-width btn-sm"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                {{ verifyButtonLabel }}
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDropVerify">
                <a class="dropdown-item" href="#" @click.prevent="setItemStatus('fulfilled')">
                    Fulfilled
                </a>
                <a class="dropdown-item" href="#" @click.prevent="setItemStatus('unfulfilled')">
                    Unfulfilled
                </a>
            </div>
        </div>

        <!-- Set Paid Dropdown -->
        <div
            v-if="order.can.set_paid"
            class="btn-group"
            role="group"
        >
            <button
                id="btnGroupDropPaid"
                type="button"
                class="btn dropdown-toggle btn-primary btn-fixed-width"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                {{ paidButtonLabel }}
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDropPaid">
                <a class="dropdown-item" href="#" @click.prevent="setOrderStatus('paid')">
                    Mark Paid
                </a>
                <a class="dropdown-item" href="#" @click.prevent="setOrderStatus('verified')">
                    Mark Unpaid
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderRowActions',

    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    computed: {
        verifyButtonLabel() {
            if (this.order.all_unfulfilled) {
                return 'Unfulfilled';
            }
            if (this.order.all_fulfilled) {
                return 'Fulfilled';
            }
            return 'Verify Order';
        },

        paidButtonLabel() {
            // Check if order status includes 'paid'
            if (this.order.status && this.order.status.includes('Paid')) {
                return 'Paid';
            }
            return 'Unpaid';
        },
    },

    methods: {
        openReview() {
            this.$emit('open-review', this.order.creative_ids, this.order.id, true);
        },

        openViewCreative() {
            this.$emit('open-view-creative', this.order.creative_ids, this.order.id, true);
        },

        setItemStatus(status) {
            this.$emit('update-item-status', this.order.order_item_ids, status);
        },

        setOrderStatus(status) {
            this.$emit('update-order-status', status);
        },
    },
};
</script>
